import { faEnvelopeOpenText } from '@fortawesome/pro-duotone-svg-icons'

import Icon from '../icon/Icon'
import { useQuickPassPings } from '../../_hooks/use-quickpass-pings'
import {
  BellButton,
  BellGlyph,
  UnreadBadge,
} from '../notifications-bell/styled'
import { PingsBellProps } from './types'

const MAX_BADGE_COUNT = 9

/**
 * Header inbox-style icon for anonymous client pings. Shows a pending
 * count badge — only counts pings the renter hasn't viewed yet.
 *
 * @param {PingsBellProps} props
 * @returns {JSX.Element}
 */
const PingsBell = ({ onClick }: PingsBellProps): JSX.Element => {
  const { pendingCount } = useQuickPassPings()
  const hasPending = pendingCount > 0
  const badgeLabel =
    pendingCount > MAX_BADGE_COUNT ? `${MAX_BADGE_COUNT}+` : `${pendingCount}`

  return (
    <BellButton
      type="button"
      onClick={onClick}
      hasUnread={hasPending}
      aria-label={
        hasPending === true ? `Open pings (${pendingCount} new)` : 'Open pings'
      }
    >
      <BellGlyph aria-hidden="true">
        <Icon icon={faEnvelopeOpenText} />
      </BellGlyph>
      {hasPending === true ? <UnreadBadge>{badgeLabel}</UnreadBadge> : null}
    </BellButton>
  )
}

export default PingsBell
